var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.5 0C11.642 0 15 2.878 15 6.429c-.429 4.928-6.214 7.928-6.857 7.928-.579 0-.637-.347-.642-1.354l-.001-.36c-4.714 0-7.5-2.664-7.5-6.214S3.358 0 7.5 0m0 1.2c-3.517 0-6.3 2.385-6.3 5.229 0 2.905 2.254 4.918 6.028 5.01l.272.004h1.198L8.7 12.84l.139-.076c.55-.308 1.136-.703 1.696-1.154l.332-.277c1.616-1.397 2.67-3.013 2.907-4.736l.025-.225-.003-.141c-.123-2.69-2.732-4.922-6.052-5.027zM4 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3.5 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2M11 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
})));
export default SvgTiktokDesktopComment;